<div class="pb-body template-business">
  <div class="container">
    <div class="template_pb">

      <!-- HEAD: navy band -->
      <header class="pb-head">
        <div class="pb-topline">
          <!-- Dynamic template name badge -->
          <div class="pb-type-badge">{{ templateName }}</div>
          <div class="pb-logo">
            <img *ngIf="logo != null" [src]="imageSrcLogo" alt="logoimage" />
            <img *ngIf="logo == null" src="assets/images/unmasking-yourself.jpg" alt="logoimage" />
          </div>
        </div>

        <div class="pb-id">
          <div class="pb-photo"><img [src]="imageSrc" alt="profileImage" /></div>
          <div class="pb-who">
            <h1>{{ firstName + ' ' + lastName }}</h1>
            <p class="pb-job">{{ jobTitle }}</p>
            <p class="pb-company" *ngIf="companyName"><i class="fa-regular fa-building"></i> {{ companyName }}</p>
          </div>
        </div>
      </header>

      <!-- Save contact -->
      <section class="pb-save" *ngIf="saveCard">
        <a class="pb-save-btn" (click)="downloadVCard()" role="button" tabindex="0">
          <i class="fa-solid fa-address-card"></i> Save Contact
        </a>
      </section>

      <!-- Contact rows -->
      <section class="pb-rows">
        <a class="pb-row" [href]="'tel:' + phone">
          <i class="fa-solid fa-phone"></i><span><small>Phone</small>{{ phone }}</span>
        </a>
        <a class="pb-row" [href]="'sms:' + phone" *ngIf="phoneAllow">
          <i class="fa-solid fa-comments"></i><span><small>Text message</small>{{ phone }}</span>
        </a>
        <a class="pb-row" [href]="'mailto:' + email">
          <i class="fa-solid fa-envelope"></i><span><small>Email</small>{{ email }}</span>
        </a>
        <a class="pb-row" *ngIf="address" [href]="'https://www.google.com/maps?q=' + address" target="_blank">
          <i class="fa-solid fa-location-dot"></i><span><small>Address</small>{{ address }}</span>
        </a>
      </section>

      <!-- About -->
      <section class="pb-about" *ngIf="content">
        <div class="pb-h"><span>About</span></div>
        <div class="pb-about-text" [innerHTML]="content"></div>
      </section>

      <div class="pb-facts" *ngIf="gpa || school || grade || height || age || weight">
        <span *ngIf="gpa"><b>GPA</b> {{ gpa }}</span>
        <span *ngIf="school"><b>School</b> {{ school }}</span>
        <span *ngIf="grade"><b>Grade</b> {{ grade }}</span>
        <span *ngIf="height"><b>Height</b> {{ height }}</span>
        <span *ngIf="age"><b>Age</b> {{ age }}</span>
        <span *ngIf="weight"><b>Weight</b> {{ weight }}</span>
      </div>

      <!-- Link buttons -->
      <section class="pb-links" *ngIf="buttons && buttons.length > 0 && buttons[0].LinkButtonTitle">
        <div class="pb-h"><span>Links</span></div>
        <ng-container *ngFor="let button of buttons">
          <a class="pb-link" *ngIf="button" [href]="button.LinkButtonLink" target="_blank" [style.border-left-color]="buttonColor || null">
            <i class="fa-solid fa-arrow-up-right-from-square" [style.color]="buttonColor || null"></i>
            <span>{{ button.LinkButtonTitle }}</span>
            <i class="pb-go fa-solid fa-chevron-right"></i>
          </a>
        </ng-container>
      </section>

      <!-- Portfolio (product images) -->
      <section class="pb-gallery" *ngIf="productImages && productImages.length > 0">
        <div class="pb-h"><span>Portfolio</span></div>
        <div class="pb-strip-scroll">
          <img *ngFor="let img of productImages; trackBy: trackByIndex" [src]="img" alt="productImage" />
        </div>
      </section>

      <!-- VIDEOS: YouTube + Umyotube (YouTube / Dailymotion / umyovideo) + Vimeo -->
      <section class="pb-videos">
        <div class="pb-sec-title" *ngIf="(youtubeArray && youtubeArray.length > 0 && youtubeArray[0].youtubeLink) || (vimeoArray && vimeoArray.length > 0 && vimeoArray[0].vimeoVideoLink) || (umyotubeArray && umyotubeArray.length > 0 && umyotubeArray[0].umyotubeLink)">
          <i class="fa-solid fa-circle-play"></i> Featured Videos
        </div>

        <ng-container *ngFor="let v of youtubeArray">
          <div class="pb-video" *ngIf="v.youtubeLink | videoEmbed as src">
            <p class="pb-video-title"><i class="fa-brands fa-youtube"></i> {{ v.youtubeTitle }}</p>
            <div class="pb-embed">
              <iframe [src]="src" [title]="v.youtubeTitle || 'YouTube player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of umyotubeArray">
          <div class="pb-video" *ngIf="v.umyotubeLink | videoEmbed as src">
            <p class="pb-video-title"><i class="fa-solid fa-circle-play"></i> {{ v.umyotubeTitle }}</p>
            <div class="pb-embed">
              <iframe [src]="src" title="Umyotube player" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of vimeoArray">
          <div class="pb-video" *ngIf="v.vimeoVideoLink | videoEmbed as src">
            <p class="pb-video-title"><i class="fa-brands fa-vimeo-v"></i> {{ v.vimeoVideoTitle }}</p>
            <div class="pb-embed">
              <iframe [src]="src" [title]="v.vimeoVideoTitle || 'Vimeo player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>
      </section>

      <section class="pb-social" *ngIf="instagram || youtube || facebook || twitter || linkedin || pinterest">
        <a [href]="instagram" target="_blank" *ngIf="instagram" class="pb-s-instagram"><i class="fa-brands fa-instagram"></i><span>Instagram</span></a>
        <a [href]="youtube" target="_blank" *ngIf="youtube" class="pb-s-youtube"><i class="fa-brands fa-youtube"></i><span>YouTube</span></a>
        <a [href]="facebook" target="_blank" *ngIf="facebook" class="pb-s-facebook"><i class="fa-brands fa-facebook-f"></i><span>Facebook</span></a>
        <a [href]="twitter" target="_blank" *ngIf="twitter" class="pb-s-twitter"><i class="fa-brands fa-twitter"></i><span>Twitter</span></a>
        <a [href]="linkedin" target="_blank" *ngIf="linkedin" class="pb-s-linkedin"><i class="fa-brands fa-linkedin-in"></i><span>LinkedIn</span></a>
        <a [href]="pinterest" target="_blank" *ngIf="pinterest" class="pb-s-pinterest"><i class="fa-brands fa-pinterest-p"></i><span>Pinterest</span></a>
      </section>

      <div class="pb-ctrls">
        <button type="button" class="ctrl-item" *ngIf="forwardCard" data-bs-toggle="modal" data-bs-target="#shareCard">
          <i class="fa-solid fa-share"></i><h3>Forward</h3>
        </button>
        <a (click)="navigateToHome()" type="button" class="ctrl-item">
          <i class="fa-solid fa-right-to-bracket"></i><h3>Sign Up</h3>
        </a>
        <button type="button" class="ctrl-item" *ngIf="saveCard" (click)="downloadVCard()">
          <i class="fa-solid fa-download"></i><h3>Save My Card</h3>
        </button>
      </div>

      <footer class="pb-footer">
        <img class="pb-qr" *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" />
        <p class="pb-strip">Trust <i></i> Quality <i></i> Results</p>
        <p class="pb-powered">This card is powered by <span>UMYO Cards</span></p>
        <form action="" class="referal-form" *ngIf="inviteCode">
          <label for="referal">Referral ID: </label>
          <input type="text" name="referal" id="referal" [value]="referal" disabled placeholder="XXXXX" />
        </form>
        <a [routerLink]="['/']" class="call-to-action">
          <span class="left">Click<br />Here</span>
          <span class="right">Design your card now!</span>
        </a>
      </footer>

    </div>
  </div>
</div>